import { Box, Typography } from "@mui/material";
import React from "react";
import styles from "./services.module.scss";
import CONSTANTS from "../../config/constants.json";

const FuneralServices = () => {
  return (
    <Box>
      {/* <img src='/hints2-ui/uir/public/images/funeralservice.jpg' /> */}
      <Typography className={styles.details}>
        <ul>
          <li><a href={CONSTANTS.DOMAIN_URL +"hints/seniors/images/insupport/Tips%20on%20Cremation-Funeral-Temple.pdf"} target="_blank" style={{color:"#f05802"}}>Tips on Cremation/Funeral and Rites After That</a></li>
        </ul>
      </Typography>
    </Box>
  );
};

export default FuneralServices;
